import React, { Fragment } from 'react';

import { IComponent } from '../../../typings/generic-component';
import { MatchPhase, MatchPhaseRound } from '../../../typings/match';
import { CtaTarget, RESULTS, Source } from '../../../typings/match-row';
import { getFooter, getHeader } from '../../../utils/match-header-footer';
import { addIsLoseOnTeams, computeFullTime } from '../../../utils/match-status';
import { makeClassNames } from '../../../utils/styles';
import { uniqueId } from '../../../utils/times'; // FIXME: need better mocked data/interfaces in tests to remove this
import MatchDataRow from '../../atoms/match-data-row/match-data-row';
import MatchTableHead from '../../atoms/match-table-head/match-table-head';
import MatchRow, { IMatchRow } from '../../molecules/match-row/match-row';

import './results-table.scss';

export interface IMatchDayList {
  date: string;
  matchList: IMatchRow[];
  roundGroup?: string | null; // BE sends NULL if COMPETITION is LINEAR
  roundName?: string | null; // BE sends NULL if COMPETITION is LINEAR
  // 2021-01-26 - Added/changed PROPS according to REAL BE data!
  competitionId?: string | number; // BE sends both STRING or NUMBER in different QUERY payloads!
  round?: number;
  seasonId?: string | number; // BE sends both STRING or NUMBER in different QUERY payloads!
  title?: string;
  // TODO: 2022-02-25: BE will MOVE these PROPS from IMatchRow to IMatchDayList to avoid DUPLICATION in EACH match!
  // Should CHECK if in ALL matchList arrays we ALWAYS have same COMPETITION PHASE/ROUND data!
  competitionPhase?: MatchPhase; // BE sends NULL if COMPETITION is LINEAR
  competitionPhaseRound?: MatchPhaseRound; // Andata/Ritorno
}

export interface IResultsTable extends IComponent {
  matchDayList: IMatchDayList[];
  margin?: boolean;
  showMatchRowLiveResult?: boolean;
  type?: Source; // Needed by MatchRow for conditional rendering
  target?: CtaTarget;
  hasTableHead?: boolean;
  isMobileDateShort?: boolean;
}

const classNames = (margin: boolean) =>
  makeClassNames({
    resultsTable: ['results-table', { 'results-table--margin': margin }],
  });

const ResultsTable = ({
  /* istanbul ignore next: default value on mandatory field */ matchDayList = [],
  /* istanbul ignore next: default value */ showMatchRowLiveResult = true,
  /* istanbul ignore next: default value */ margin = true,
  /* istanbul ignore next: default value */ type = RESULTS,
  colorSchema,
  size,
  trackingData,
  target,
  hasTableHead = true,
  isMobileDateShort = true,
}: IResultsTable) => {
  const cn = classNames(margin);

  const hasRoundGroup = matchDayList.length > 0 && matchDayList[0].roundGroup !== null;
  return (
    <table className={cn.resultsTable}>
      {hasTableHead && <MatchTableHead hasRoundGroup={hasRoundGroup} />}
      <tbody>
        {matchDayList.map((matchDay: IMatchDayList) => {
          return (
            <Fragment key={`${matchDay.competitionId ?? uniqueId()}-${matchDay.date ?? uniqueId()}`}>
              <MatchDataRow
                key={matchDay.date ?? uniqueId()}
                date={matchDay.date}
                title={matchDay.title}
                colorSchema={colorSchema}
                roundName={matchDay.roundName}
                dateTimeFormatLong="dddd D MMM YYYY"
                dateTimeFormatShort="ddd D MMM"
                isMobileDateShort={isMobileDateShort}
              />
              {matchDay.matchList
                .map(addIsLoseOnTeams)
                // FIXME: LC 2021-02-17 - COMPUTE match until new 'FullTimeAfterShootOut' and 'FullTimeAfterShootOut' statuses will be provided by BE!
                .map(computeFullTime)
                .map((match: IMatchRow) => {
                  const header = getHeader(match);
                  const footer = getFooter(match);
                  return (
                    <MatchRow
                      {...match}
                      key={match.id ?? match.matchId ?? uniqueId()}
                      colorSchema={colorSchema}
                      size={size}
                      showLiveResult={showMatchRowLiveResult}
                      header={header}
                      footer={footer}
                      type={type}
                      trackingData={trackingData}
                      target={target}
                      roundGroup={matchDay.roundGroup}
                      linkArialabel={`Vai alla partita ${match.home.name} - ${match.away.name}`}
                    />
                  );
                })}
            </Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export default ResultsTable;
